/* eslint-disable max-len */
import React from "react"
import Pagination from "../../../components/Pagination"
import { formatAdjustedDate } from '../../../CommonMethods/formatDate';

const SubInventoryTable = ({
    SubInventoryList,
    searchParams, 
    setSearchParams,  
    setPageLoading, 
    SubInventoryCount}) => {
        
    /**
     * The function `handleOnClickPageNumber` updates the search parameters with a new page number and sets
     * the page loading state to true.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setPageLoading(true);
        const params = Object.fromEntries(searchParams) 
        setSearchParams({ ...params, page_number_sub_inventory: pageNum.selected + 1 })
    }

    return(
        <div class=" w-full relative">
            <div class=" overflow-x-auto pb-2.5 scroll-bar -mx-[2px]">
                <div class={`flex px-[6px] mt-2 ${SubInventoryCount > 50 ? 'max-h-[calc(100vh-268px)]' : 'max-h-[calc(100vh-228px)]'}`}>
                    <table aria-label="Outside Table" class="w-full relative stickyhead" id="admin-table">
                        <thead>
                            <tr className='shadow-s13 rounded-t-[16px] rounded-b-[16px] bg-[#C2DCEF]'>
                                <th class="w-[10%]">
                                    <span></span>
                                </th>
                                <th class="w-[12%]">
                                    <span></span>
                                </th>
                                <th colSpan={3} class="w-[32%]"> 
                                    <span class="flex items-center justify-center">Inwards</span>
                                </th>
                                <th colSpan={3} class="w-[32%]">
                                    <span class="flex items-center justify-center">Outwards</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody >
                            <tr aria-colspan="8" class="relative h-0.5 z-[-10]"></tr>
                            <tr class="group">
                                <td class="font-semibold">Date</td>
                                <td class="font-semibold ">Reference #</td>

                                <td class="text-end  font-semibold min-w-[50px]">Qty</td>
                                <td class="text-end  font-semibold min-w-[70px]">Value/Qty(CP)</td>
                                <td class="text-end  font-semibold border-r border-[#C2DCEF] min-w-[50px]">Value</td>

                                <td class="text-end  font-semibold min-w-[50px]">Qty</td>
                                <td class="text-end  font-semibold min-w-[70px]">Value/Qty(SP)</td>
                                <td class="text-end  font-semibold min-w-[50px]">Value</td>
                            </tr>
                            <tr aria-colspan="8" class="relative h-0.5 z-[-10]"></tr>
                            <tr class="group">
                                <td colSpan={7} class="text-start">Opening Stock: Quantity: <span id='ob_qty'>{SubInventoryList?.closing_and_opening_balance[0]?.opening_stock_quantity || '-'}</span>, Value: <span id='ob_value'>{parseFloat(SubInventoryList?.closing_and_opening_balance[0]?.opening_stock_amount).toFixed(2) || '-'}</span></td>
                                <td class="text-end"></td>
                            </tr>
                            {SubInventoryList?.inward_and_outward?.map((inventory, index) => (
                                <>
                                    <tr id="list-items" aria-colspan="8" class="relative h-0.5 z-[-10]"></tr>
                                    <tr class="group" key={index+inventory?._id}>
                                        <td class="text-start  border-r border-[#C2DCEF] " id={'date'+index}>{formatAdjustedDate(inventory?.issued_date || inventory?.grn_date)}</td>
                                        <td class="text-start  border-r border-[#C2DCEF] " id={'reference'+index}>{inventory?.reference || '-'}</td>

                                        <td class="text-end " id={'inwards_qty'+index}>{inventory?.inward_qty || '-'}</td>
                                        <td class="text-end " id={'inwards_value_qty'+index}>{parseFloat(inventory?.inward_cost_price).toFixed(2) || '-'}</td>
                                        <td class="text-end  border-r border-[#C2DCEF]" id={'inwards_value'+index}>{parseFloat(inventory?.inward_total_amount).toFixed(2) || '-'}</td>
                                        
                                        <td class="text-end " id={'outwards_qty'+index}>{inventory?.outward_qty || '-'}</td>
                                        <td class="text-end " id={'outwards_value_qty'+index}>{parseFloat(inventory?.outward_selling_price).toFixed(2) || '-'}</td>
                                        <td class="text-end"  id={'outwards_value'+index}>{parseFloat(inventory?.outward_total_amount).toFixed(2) || '-'}</td>
                                    </tr>
                                </>))}
                            <tr aria-colspan="8" class="relative h-0.5 z-[-10]"></tr>
                            <tr class="group">
                                <td colSpan={7} class="text-start">Closing Stock: Quantity: <span id='cb_qty'>{SubInventoryList?.closing_and_opening_balance[0]?.closing_stock_quantity || '-'}</span>, Value: <span id='cb_value'>{parseFloat(SubInventoryList?.closing_and_opening_balance[0]?.closing_stock_amount).toFixed(2)|| '-'}</span></td>
                                <td class="text-end"></td>
                            </tr>
                        </tbody>
                        
                    </table>
                </div>
            </div> 
            <div className="">              
                {SubInventoryCount > 50 &&  <Pagination
                    TotalCount={SubInventoryCount}
                    limit={50}
                    totalPageNumber={Math?.ceil(SubInventoryCount / 50)}
                    selectedPageNumber={Number(searchParams.get('page_number_sub_inventory')) || 1}
                    handleOnClickPageNumber={handleOnClickPageNumber}
                />}
            </div> 
        </div>
    )
}

export default SubInventoryTable;